import {
	instance
} from '../../util/http'
import apis from '../../config/apis'
// 销售业绩确认
const post = (data) => {
	return instance.post(apis.Sale.ConfirmSale, data)
}
// 销售业绩确认     
const GetSalesApprovalList = (SaleStatus,Page, PageSize) => {
	return instance.get(apis.Sale.GetSalesApprovalsByStatus + "?SaleStatus=" + SaleStatus +  "&Index=" + Page + "&Size=" + PageSize)
}
// 根据年月获取下级销售业绩
const GetSalesRecord = (Year,Month,Page, PageSize) => {
	return instance.get(apis.Sale.GetSalesRecord + "?Year=" + Year +  "&Month=" + Month +  "&Index=" + Page + "&Size=" + PageSize)
}
// 获取我的销售业绩（店长，店员，绑定用户共用）
const GetMySalesRecord = () => {
	return instance.get(apis.Sale.GetMySalesRecord)
}
const GetDateByMonthNum = (monthNum) => {
	return instance.get(apis.Sale.GetDateByMonthNum + "?monthNum=" + monthNum)
}
// 获取销售审批待确认数量
const GetSalesApprovalQuantity = () => {
	return instance.get(apis.User.GetSalesApprovalQuantity)
}
 

export default {
	post,
	GetSalesApprovalList,
	GetSalesRecord,
	GetMySalesRecord,
	GetDateByMonthNum,
	GetSalesApprovalQuantity
}